import React, {Component} from 'react';
import { Slider } from 'carbon-components-react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class CCSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.min = 0;
		this.max = 127;
		this.ccBipolar = (props.ccBipolar && props.ccBipolar != 0) ? true : false;

		this.handleChange = this.handleChange.bind(this);
		this.formatLabel  = this.formatLabel.bind(this);
	}

	render() {
		/*
		 * min: minimum value
		 * max: maximum value
		 * step: 
		 * stepMultiplier: (note: it is misspelled as 'stepMuliplier' in the
		 * Carbon Slider component)
		 * formatLabel: used to format 
		 */
		return (
			<Slider value={this.state.value} min={this.min} max={this.max} step={1} stepMuliplier={8} stepMulitplier={8} labelText={this.labelText} formatLabel={this.formatLabel} onChange={this.handleChange} disabled={this.state.disabled} hideTextInput="1"/>
		);
	}

	handleChange(props) {
		var newValue = Number(props.value)
		this.setState({value: newValue});
		midi.sendControlChange(this.ccNum, newValue);
	}

	formatLabel(value, label) {
		return '';
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue);
	}

	setValue(x) {
		this.setState({value: x});
	}
}

export default CCSlider;
